import { Component, Input, OnInit } from '@angular/core';

import type { ICellRendererAngularComp } from 'ag-grid-angular';
import { Release } from '../models/release';

@Component({
  standalone: false,
  selector: 'app-release-success-failure-renderer',
  template: `

<ng-template #undefinedTpl>
  <span>-</span>
</ng-template>
<div>
  @if (booleanValue !== undefined) {
    @if (booleanValue === false) {
      @if (isWarning) {
        <mat-icon style="color: orange; justify-content: center">warning</mat-icon>
      }
      @if (!isWarning) {
        <mat-icon style="color: red; justify-content: center">cancel</mat-icon>
      }
    } @else {
      <mat-icon style="color: green; justify-content: center"
        >check_circle</mat-icon
        >
      }
    } @else {
      <span>-</span>
    }
    @switch (booleanValue) {
      @case (false) {
        <ng-container #failure></ng-container>
      }
      @case (true) {
        <ng-container #success></ng-container>
      }
      @case (undefined) {
        <ng-container #undefinedTpl></ng-container>
      }
      @default {
        <ng-container #undefinedTpl></ng-container>
      }
    }
  </div>
`,
  styleUrls: [],
  styles: `
    :host {
      height: inherit;
    }
  `,
})
export class ReleaseSuccessFailureRenderer implements ICellRendererAngularComp, OnInit {
  @Input() release!: Release;
  @Input() booleanValue!: boolean | undefined;
  @Input() booleanPropertyName!: string;
  @Input() isWarning!: boolean;
  @Input() invertCondition!: boolean;
  @Input() falseIsNull!: boolean;
  @Input() trueIsNull!: boolean;

  isProcessed: boolean = false;

  ngOnInit(): void {
    this.init();
  }

  init(): void {
    if(this.falseIsNull && this.trueIsNull) {
      console.warn('falseIsNull and trueIsNull cannot both be true');
    }
    if (this.isProcessed) {
      return;
    }
    if (this.invertCondition) {
      this.booleanValue = !this.booleanValue;
    }
    if (this.falseIsNull && this.booleanValue === false) {
      this.booleanValue = undefined;
    }
    if (this.trueIsNull && this.booleanValue === true) {
      this.booleanValue = undefined;
    }
    this.isProcessed = true;
  }

  agInit(params: any): void {
    this.isWarning = params.isWarning;
    this.invertCondition = params.invertCondition;
    this.falseIsNull = params.falseIsNull;
    this.trueIsNull = params.trueIsNull;
    this.release = params.data;
    this.booleanValue = params.data[params.booleanPropertyName];

    if(this.booleanValue === undefined) {
      console.warn(`booleanValue is undefined for ${params.data.id} in ReleaseSuccessFailureRenderer`);
    }
    this.init();
  }

  refresh(params: any): boolean {
    return true;
  }
}
